import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams((window.location.hash || "").replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } });
        if (data.is_new && window.fbq) { window.fbq("track", "CompleteRegistration"); }
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.is_admin ? "/admin" : data.profile_complete ? "/dashboard" : "/onboarding", { replace: true });
      } catch (e) {
        window.history.replaceState(null, "", "/");
        window.location.href = "/";
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-10 w-10 text-brand-pink mx-auto mb-4 animate-spin" />
        <p className="font-heading font-bold text-lg">Signing you in…</p>
      </div>
    </div>
  );
}
